<template>
  <div id="theReport" class="report-container">
    <div class="header-bar">
      <h2>Revenue Report</h2>
      <button
        @click="printReport('theReport', 'revenue' + startDate)"
        class="print-button exclude-print"
      >
        🖨 Print
      </button>
    </div>

    <div class="date-filters">
      <label>
        From:
        <input type="date" v-model="startDate" />
      </label>
      <label>
        To:
        <input type="date" v-model="endDate" />
      </label>
      <button class="exclude-print" @click="fetchRevenue">Load Report</button>
    </div>

    <div v-if="totalRevenue !== null" class="total-revenue">
      <h3>Total Revenue: Ksh. {{ totalRevenue.toLocaleString() }}</h3>
    </div>

    <div v-if="paymentMethods.length" class="breakdown">
      <h4>Breakdown by Payment Method</h4>
      <table>
        <thead>
          <tr>
            <th>Payment Method</th>
            <th>Amount (Ksh.)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(method, index) in paymentMethods" :key="index">
            <td>{{ method.name }}</td>
            <td>{{ method.value.toLocaleString() }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row equal-height">
      <div class="col-sm-6 chart-wrapper">
        <canvas v-if="keys.length > 0" id="departmental-rev-chart"></canvas>
      </div>
      <div class="col-sm-6 table-wrapper">
        <div v-if="departments.length" class="breakdown">
          <h4>Breakdown by Department</h4>
          <table>
            <thead>
              <tr>
                <th>Department</th>
                <th>Amount (Ksh.)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(dept, index) in departments" :key="index">
                <td>{{ dept.name }}</td>
                <td>{{ dept.value.toLocaleString() }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import PrintDiv from "../../prints/div_to_pdf";
import Chart from "chart.js/auto";
// import MsterGraphCanvas from "../Patients/components/master_graph_canvas.vue";

export default {
  data() {
    const today = new Date().toISOString().substr(0, 10);
    return {
      startDate: today,
      endDate: today,
      totalRevenue: null,
      paymentMethods: [],
      departments: [],
      keys: [],
      values: [],
      chart: null,
    };
  },
  components: {
    // MsterGraphCanvas,
  },
  methods: {
    project_chart_data(departments) {
      var keys = [];
      var values = [];
      departments.forEach((element) => {
        keys.push(element.name);
        values.push(element.value);
      });

      const ctx = document
        .getElementById("departmental-rev-chart")
        .getContext("2d");

      // Destroy existing chart instance if it exists
      if (this.chart) {
        this.chart.destroy();
      }

      this.chart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: keys,
          datasets: [
            {
              label: "Revenue",
              data: values,
              tension: 0.4,
              fill: true,
              backgroundColor: "rgba(65, 190, 12, 0.7)",
              borderColor: "rgba(75, 192, 192, 1)",
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: { display: true },
          },
        },
      });
    },

    printReport(div, name) {
      return PrintDiv(div, name);
    },
    async fetchRevenue() {
      if (!this.startDate || !this.endDate) {
        alert("Please select both dates.");
        return;
      }
      var req_body = {
        startDate: this.startDate,
        endDate: this.endDate,
      };

      const url = `finance/getRevenueByDateRange`;
      const res = await generalApiRequest(url, "POST", req_body, 1);
      console.log(res);

      if (res.status === "success") {
        this.totalRevenue = res.data.totalRevenue;
        this.paymentMethods = res.data.byPaymentMethod;
        this.departments = res.data.byDepartment;
        this.keys = res.data.keys;
        this.values = res.data.values;
        this.$nextTick(() => {
          this.project_chart_data(res.data.byDepartment);
        });
        // this.project_chart_data(res.data.byDepartment);
      } else {
        alert("Failed to fetch report.");
      }
    },
  },
  mounted() {
    this.fetchRevenue(); // auto-fetch for today's data on mount
  },
};
</script>

<style scoped>
.chart-wrapper {
  max-height: 400px;
}
.row {
  display: flex;
  gap: 20px;
}

.col-sm-6 {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.col-sm-6 canvas {
  flex: 1;
  /* Make sure canvas fills its parent height */
  width: 100% !important;
  height: auto !important;
}
.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.print-button {
  background-color: #4caf50;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  font-size: 0.9rem;
  transition: background-color 0.2s ease-in-out;
}

.print-button:hover {
  background-color: #43a047;
}
.report-container {
  max-width: 900px;
  margin: 40px auto;
  padding: 20px;
  border: 1px solid #e2e2e2;
  border-radius: 12px;
  background: #fafafa;
}

.date-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.date-filters label {
  font-weight: 500;
}

.date-filters input {
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.date-filters button {
  padding: 8px 16px;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.date-filters button:hover {
  background: #218838;
}

.total-revenue {
  margin-bottom: 30px;
  background: #e6ffe6;
  padding: 15px;
  border-radius: 8px;
}

.breakdown {
  margin-bottom: 30px;
}

.breakdown table {
  width: 100%;
  border-collapse: collapse;
}

.breakdown th,
.breakdown td {
  padding: 10px 12px;
  border: 1px solid #ddd;
  text-align: left;
}

.breakdown th {
  background: #f1f1f1;
}
</style>
